import { formatIsoDateCustom } from '@/global/services/helpers/dates'
import { cloneDeep } from 'lodash'
import documentsHistoryHelper from '../documents-history-helper'

const FORM_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DISPLAY_DATETIME_FORMAT = 'DD.MM.YYYY.'
export default {
  name: 'Sketch',

  mixins: [
    documentsHistoryHelper
  ],

  computed: {
    sketchConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.sketch'),
        key: 'sketch',
        visible: this.$route.query.category !== 'request_new',
        apiConfig: {
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/sketch`,
            method: 'get'
          }
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance/aggregator.sketch'),
            showEditButtons: false,
            showBackButton: {
              uiViewName: this.$route?.meta?.parent_vue_name ?? null
            },
            additional_buttons: [
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                click: (event) => this.onChangeStatus(event)
              }
            ]
          },
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-internal-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.document_flow'),
            visible: true,
            buttons: [
              {
                label: this.$t('road-maintenance/aggregator.new_document'),
                color: '#65AD45',
                prependIcon: 'mdi-plus',
                prependIconStyle: { color: '#FFFFFF !important' },
                style: { color: '#FFFFFF !important' },
                click: (event) => this.onUploadSketch(event)
              }
            ],
            columnsConfig: [
              {
                key: 'created_at',
                title: this.$t('fleet/documents/prl_cargo.creation_date') + ':',
                valueClass: 'history-block-value',
                customValue: (data) => {
                  return data?.created_at ? formatIsoDateCustom(data.created_at, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : ''
                }
              },
              {
                key: 'description',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/patrol-service.description') + ':'
              },
              {
                key: 'created_by',
                valueClass: 'history-block-value',
                title: this.$t('fleet/vehicle_reservation.created_by') + ':'
              },
              {
                key: 'document_name',
                title: this.$t('road-maintenance/aggregator.document') + ':',
                valueClass: 'history-block-value',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                click: (event) => this.downloadSketch(event)
              }
            ],
            dataKey: 'sketches'
          }
        ]
      }
    }
  },

  methods: {
    onUploadSketch (event) {
      const { formData, updateData, fetchTabData } = event || {}
      this.$set(this.uploadSketchDialogConfig, 'showDialog', true)
      this.$set(this.uploadSketchDialogConfig.config, 'formData', cloneDeep(formData))
      this.$set(this.uploadSketchDialogConfig.config, 'updateData', (val) => updateData(val))
      if (typeof fetchTabData === 'function') {
        this.$set(this.uploadSketchDialogConfig.config, 'fetchTabData', () => fetchTabData())
      }
    },

    async downloadSketch (event) {
      let objectURL = null

      try {
        const { id: sketchId } = event?.rowData || {}

        if (!sketchId) {
          console.error('Missing document id')
          return
        }

        const url = new URL(`${window.location.origin}/api/road-maintenance/traffic-regulation/${this.$route.params.id}/attachment/${sketchId}`)

        const response = await fetch(url.toString(), {
          method: 'POST'
        })

        if (!response.ok) {
          console.error(`Failed to show download sketch: HTTP ${response.status} - ${response.statusText}`)
          return
        }

        const contentType = response.headers.get('Content-type')
        const contentDisposition = response.headers.get('Content-Disposition')
        const arrayBuffer = await response.arrayBuffer()

        // Create a Blob from the response data
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: contentType
        })

        // Generate object URL for downloading
        objectURL = URL.createObjectURL(blob)
        const filename = contentDisposition?.split('filename=')[1] ?? 'File'

        // Trigger download
        const link = document.createElement('a')
        link.href = objectURL
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      catch (exception) {
        console.error(exception.message || exception)
      }
      finally {
        if (objectURL) {
          URL.revokeObjectURL(objectURL)
        }
      }
    }
  }
}
